import { useEffect } from "react";

const useUtmTracking = () => {
  const getUrlParameter = (name) => {
    return new URLSearchParams(window.location.search).get(name) || "";
  };

  const getCookieDomain = () => {
    const hostname = window.location.hostname;
    if (hostname === "localhost" || /^\d+\.\d+\.\d+\.\d+$/.test(hostname)) return "";
    const parts = hostname.split(".");
    return parts.length > 2 ? "." + parts.slice(-2).join(".") : "";
  };

  const setCookie = (name, value, days) => {
    let expires = "";
    if (days) {
      const date = new Date();
      date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
      expires = "; expires=" + date.toUTCString();
    }
    const domain = getCookieDomain();
    const domainAttr = domain ? `; domain=${domain}` : "";
    document.cookie = `${name}=${encodeURIComponent(value || "")}${expires}${domainAttr}; path=/; Secure; SameSite=Lax`;
  };

  const getCookie = (name) => {
    const nameEQ = name + "=";
    const ca = document.cookie.split(";");
    for (let i = 0; i < ca.length; i++) {
      let c = ca[i].trim();
      if (c.indexOf(nameEQ) === 0) return decodeURIComponent(c.substring(nameEQ.length, c.length));
    }
    return null;
  };

  useEffect(() => {
    const utmParams = ["utm_source", "utm_medium", "utm_content", "utm_campaign", "utm_term"];

    utmParams.forEach((param) => {
      const value = getUrlParameter(param);
      if (value) {
        setCookie(param, value, 7);
        const cookieValue = getCookie(param);
        document.querySelectorAll(`[name=${param}]`).forEach((field) => (field.value = cookieValue));
      }
    });
  }, []);
};

export default useUtmTracking;